module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Care Calculator",
      "icon": "care-calculator"
    }
  }), _vm._v(" "), _vm._l((_vm.periods), function(period, index) {
    return _c('care-period', {
      attrs: {
        "index": index,
        "period": period
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller",
    on: {
      "click": _vm.addCarePeriod
    }
  }, [_vm._v("\n                Add Care Period\n            ")]), _vm._v(" "), _c('h2', [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "sub_total",
      "label": "Total",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.total, '')
    }
  })])], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showExplanation),
      expression: "showExplanation"
    }],
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('modal', {
    attrs: {
      "name": "care-rates",
      "noDefaultButton": true
    }
  }, [_c('h1', [_vm._v("\n                    Care and Attendance Rates\n                ")]), _vm._v(" "), (!_vm.isLoading()) ? _c('table', {
    staticClass: "a-table a-table--full-width"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Basic")]), _vm._v(" "), _c('th', [_vm._v("Aggregate")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rates), function(careRate, date) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatModalDate(date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(careRate.basic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(careRate.aggregate))])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v("Explanation")]), _vm._v(" "), _vm._l((_vm.periods), function(period, index) {
    return _c('div', [_c('h2', [_vm._v("Period " + _vm._s(index + 1))]), _vm._v(" "), _c('p', [_vm._v("\n                    The total cost of care for the period between "), _c('strong', [_vm._v(_vm._s(_vm.getPeriodStart(period)))]), _vm._v(" and\n                    "), _c('strong', [_vm._v(_vm._s(_vm.getPeriodEnd(period)))]), _vm._v(", at the "), _c('strong', [_vm._v(_vm._s(period.rate))]), _vm._v(" rate, for\n                    "), _c('strong', [_vm._v(_vm._s(period.hoursPerDay) + " hour" + _vm._s(period.hoursPerDay === 1 ? '' : 's'))]), _vm._v(" per day has\n                    been calculated to be "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(period.total)))]), _vm._v(".\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    This has been calculated using the formula:\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "m-formula"
    }, [_c('div', {
      staticClass: "m-formula__item--row"
    }, [_c('strong', [_vm._v("\n                            [Total Hours] x [Care Rate] = [Total Cost of Care]\n                        ")])])]), _vm._v(" "), _vm._l((period.table[0]), function(table) {
      return (period.table[0].length == 1) ? _c('p', [_vm._v("\n                    Where the total number of hours is "), _c('strong', [_vm._v(_vm._s(table.totalHours))]), _vm._v(" and the\n                    " + _vm._s(period.rate) + " care rate is taken as\n                    "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(table.rates[period.rate])))]), _vm._v(".\n                ")]) : _vm._e()
    }), _vm._v(" "), (period.table[0].length > 1) ? _c('p', [_vm._v("\n                    As the care period spans multiple recommended rates for care and attendance, each period must be broken\n                    down and totalled up individually using the appropriate rate for each period. You can view these rates\n                    by clicking "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleCareRatesModal()
        }
      }
    }, [_vm._v("here")]), _vm._v(".\n                ")]) : _vm._e(), _vm._v(" "), (period.gratuitousCare) ? _c('p', [_vm._v("\n                    Since you have specified that the care provided was gratuitous (provided by a family member or friend\n                    without charge), a discount of 25% must be applied to the above total figure. The resulting total cost\n                    of care is therefore: "), _c('strong', [_vm._v(_vm._s(_vm.currencyFormat(period.total)))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "a-table a-table--short-no-style a-table--full-width"
    }, [(period.table[0].length > 0) ? _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                                Period Start\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Period End\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Total Days\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Total Hours\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                " + _vm._s(period.rate.charAt(0).toUpperCase() + period.rate.slice(1)) + " Rate\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Total\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((period.table[0]), function(table) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatDate(table.start.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(table.end.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table.totalDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(table.totalHours))]), _vm._v(" "), _c('td', [_vm._v("\n                                £" + _vm._s(_vm.twoDp(!period.gratuitousCare ? table.rates[period.rate] : table.rates[period.rate] * 0.75)) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(table.total)) + "\n                            ")])])
    }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "5"
      }
    }), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(period.total)) + "\n                            ")])])])]) : _vm._e()])], 2)
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d16e1a3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/careCalculator.vue
// module id = 1652
// module chunks = 0